import { AutoAwesome } from '@mui/icons-material';
import { Box, SxProps } from '@mui/material';

import { useChatUI } from '~/features/ChatBotDialog/useChatUI';

type PropsType = {
  sx?: SxProps;
};

export const AIChatbotButton = (props: PropsType) => {
  const { sx } = props;

  const { toggle: toggleChat } = useChatUI();

  return (
    <Box
      sx={sx}
      onClick={toggleChat}
      title="solAIris"
      role="button"
      aria-label="Open solAIris"
    >
      <AutoAwesome fontSize="inherit" />
    </Box>
  );
};
